import { dayjs } from "@/lib/dayjs";
import clsx from "clsx";
import type { YurplanConferencesType } from "database";
import Link from "next/link";

type YurplanCalendarConference = {
  id: number;
  dateStart: string;
  title: string;
  type: YurplanConferencesType;
  price: number | null;
  slug: string;
  coverUrl: string | null;
  description?: string;
  speaker: {
    id: number;
    firstname: string | null;
    lastname: string | null;
    alias: string | null;
    imageName: string | null;
    imageRealname: string | null;
  } | null;
};

type LivestormCalendarConference = {
  id: string;
  dateStart: string;
  title: string;
  slug: string;
  coverUrl: string | null;
  description?: string;
  speaker: {
    id: number;
    firstname: string | null;
    lastname: string | null;
    alias: string | null;
    imageName: string | null;
    imageRealname: string | null;
  } | null;
};

type Props = {
  conference: YurplanCalendarConference | LivestormCalendarConference;
};
export const Conference = ({ conference }: Props) => {
  return (
    <Link
      href={`/conferenciers/conference/${"type" in conference ? "y" : "l"}-${conference.id}-${conference.slug}`}
      className="no-underline drop-shadow-sm bg-white text-primary flex flex-col items-center group"
      title={conference.title}
    >
      <div className="h-24 w-full relative">
        <div className="overflow-hidden absolute top-0 right-0 bottom-0 left-0">
          {conference.coverUrl && (
            <img
              className="absolute top-0 left-0 w-full h-full text-transparent object-cover group-hover:scale-105 transition-all"
              src={conference.coverUrl}
              alt=""
            />
          )}
        </div>
        <p
          className={clsx(
            "absolute -bottom-[14px] text-white left-1/2 -translate-x-1/2 whitespace-nowrap w-44 py-2 text-center uppercase text-[10px] leading-3 font-semibold",
            {
              "bg-[#EB7D3C]": "type" in conference && conference.type === "promenades",
              "bg-[#044B3E]": ("type" in conference && conference.type === "intermedes") || !("type" in conference),
              "bg-[#00B25D]": "type" in conference && conference.type === "cafe",
            },
          )}
        >
          {"type" in conference && conference.type === "promenades" ? "Promenade culturelle" : ""}
          {("type" in conference && conference.type === "intermedes") || !("type" in conference) ? "conférence" : ""}
          {"type" in conference && conference.type === "cafe" ? "Café-conférence" : ""}
        </p>
      </div>
      <p className="text-[10px] leading-3 font-semibold mt-5 text-center">
        {`Le ${dayjs(conference.dateStart).format("DD MMM YYYY")}`}
      </p>
      <p className="text-[15px] leading-5 font-semibold line-clamp-2 h-[40px] text-center mt-2 px-1">
        {conference.title}
      </p>
      {conference.speaker && conference.speaker.id !== 1 && (
        <p className="text-[10px] leading-3 text-center line-clamp-1 mt-2 uppercase">{`Avec ${conference.speaker.firstname} ${conference.speaker.lastname}`}</p>
      )}
      {conference.description && (
        <div className="line-clamp-3 px-4 mt-4 text-sm h-[60px]">{conference.description}</div>
      )}
      <div className="grow" />
      <span className="mt-2 mb-3 no-underline text-primary border border-primary rounded-sm text-[10px] leading-3 font-semibold uppercase py-2 w-52 text-center">
        {"price" in conference ? `Réserver ${conference.price ? `(${conference.price} €)` : ""}` : "Réserver (gratuit)"}
      </span>
    </Link>
  );
};
